export const images = {
  logo: require("./checkfirst-logo.png"),
  videoPlay: require("./videoPlay.png"),
};
